import React from 'react';
import Icon from '../../../components/AppIcon';

const SubscriptionSummary = ({ subscription }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-foreground">Subscription Summary</h2>
        <Icon name="CreditCard" size={24} color="var(--color-primary)" />
      </div>
      <div className="space-y-4">
        <div className="flex items-center justify-between pb-4 border-b border-border">
          <div>
            <p className="text-sm text-muted-foreground">Plan Type</p>
            <p className="text-lg font-semibold text-foreground">{subscription?.planType}</p>
          </div>
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-success/10 text-success">
            Active
          </span>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Active Modules</p>
            <p className="text-2xl font-bold text-primary">{subscription?.activeModules}</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground mb-1">Total Locations</p>
            <p className="text-2xl font-bold text-primary">{subscription?.totalLocations}</p>
          </div>
        </div>

        <div className="pt-4 border-t border-border">
          <div className="flex items-center justify-between mb-2">
            <p className="text-sm text-muted-foreground">Module Usage</p>
            <p className="text-sm font-medium text-foreground">{subscription?.moduleUsage}%</p>
          </div>
          <div className="w-full bg-muted rounded-full h-2">
            <div
              className="bg-primary rounded-full h-2 transition-all duration-300"
              style={{ width: `${subscription?.moduleUsage}%` }}
            />
          </div>
        </div>

        <div className="pt-4 border-t border-border space-y-2">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Renewal Date:</span>
            <span className="font-medium text-foreground">{subscription?.renewalDate}</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Support Level:</span>
            <span className="font-medium text-foreground">{subscription?.supportLevel}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSummary;